/** Small inline stroke icons (24-unit grid, currentColor) — no icon library download needed. */
const P: Record<string, string> = {
  chat: 'M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z|M8.5 11h.01|M12 11h.01|M15.5 11h.01',
  sparkle: 'M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8z|M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z',
  grid: 'M4 4h7v7H4z|M13 4h7v7h-7z|M4 13h7v7H4z|M13 13h7v7h-7z',
  shape: 'M12 2l9 5v10l-9 5-9-5V7z|M12 22V12|M21 7l-9 5-9-5',
  vessel: 'M3 17l2 4h14l2-4z|M5 17V11h14v6|M8 11V7h8v4|M12 3v4',
  hull: 'M2 10h20l-3 7c-1 2-3 3-5 3H10c-2 0-4-1-5-3z|M2 14h20',
  paint: 'M19 3a2 2 0 0 1 2 2c0 4-6 8-8 10l-4-4c2-2 6-8 10-8z|M9 11c-3 0-5 2-5 5 0 2-1 3-2 3 2 2 6 2 8 0 1-1 2-3 2-5',
  type: 'M4 7V4h16v3|M9 20h6|M12 4v16',
  bolt: 'M13 2L4 14h7l-1 8 9-12h-7z',
  scale: 'M12 3v18|M5 21h14|M3 8l3-5 3 5a3 3 0 0 1-6 0z|M15 8l3-5 3 5a3 3 0 0 1-6 0z|M6 3h12',
  check: 'M9 11l3 3L22 4|M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11',
  bot: 'M12 8V4H8|M4 8h16v12H4z|M2 14h2|M20 14h2|M9 13v2|M15 13v2',
  list: 'M8 6h13|M8 12h13|M8 18h13|M3 6h.01|M3 12h.01|M3 18h.01',
  folder: 'M3 6a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
  history: 'M3 12a9 9 0 1 0 3-6.7L3 8|M3 3v5h5|M12 7v5l4 2',
  focus: 'M3 7V3h4|M17 3h4v4|M21 17v4h-4|M7 21H3v-4|M9 9h6v6H9z',
  ruler: 'M2 16L16 2l6 6L8 22z|M7 11l2 2|M10 8l2 2|M13 5l2 2',
  eye: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z|M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z',
  layers: 'M12 2l10 5-10 5L2 7z|M2 12l10 5 10-5|M2 17l10 5 10-5',
  cube: 'M12 2l9 5v10l-9 5-9-5V7z|M3 7l9 5 9-5|M12 12v10',
  sun: 'M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8z|M12 2v2|M12 20v2|M4.9 4.9l1.4 1.4|M17.7 17.7l1.4 1.4|M2 12h2|M20 12h2|M4.9 19.1l1.4-1.4|M17.7 6.3l1.4-1.4',
  lock: 'M5 11h14v10H5z|M8 11V7a4 4 0 0 1 8 0v4',
  edit: 'M12 20h9|M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z',
  send: 'M12 19V5|M5 12l7-7 7 7',
  coin: 'M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18z|M9 9.5c0-1 1.3-1.5 3-1.5s3 .7 3 1.8c0 2.4-6 1.4-6 4 0 1 1.3 1.7 3 1.7s3-.6 3-1.6|M12 6.5v1.5|M12 16v1.5',
  help: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z|M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3|M12 17h.01',
  book: 'M4 4.5A2.5 2.5 0 0 1 6.5 2H20v17H6.5A2.5 2.5 0 0 0 4 21.5z|M4 21.5A2.5 2.5 0 0 1 6.5 19H20v3H6.5|M8 7h8|M8 11h6',
  search: 'M11 4a7 7 0 1 1 0 14 7 7 0 0 1 0-14z|M21 21l-4.3-4.3',
  bell: 'M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9|M10.3 21a1.9 1.9 0 0 0 3.4 0',
  home: 'M3 10.5L12 3l9 7.5|M5 9v11h14V9|M10 20v-6h4v6',
  wire: 'M3 3h18v18H3z|M3 9h18|M3 15h18|M9 3v18|M15 3v18',
};
export function Icon({ n, size = 18, className }: { n: keyof typeof P | string; size?: number; className?: string }) {
  return <svg className={`ico ${className ?? ''}`} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{(P[n] ?? P.cube).split('|').map((d, i) => <path key={i} d={d} />)}</svg>;
}
